import { render, staticRenderFns } from "./UserDeleteDialog.vue?vue&type=template&id=1206df2f&scoped=true"
import script from "./UserDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./UserDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./UserDeleteDialog.vue?vue&type=style&index=0&id=1206df2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1206df2f",
  null
  
)

export default component.exports